<template>
  <v-card :class="card_color_class" :style="{opacity: (is_past ? 0.4 : 1.0)}">
    <v-card-title class="pa-0" @click="open_editor" style="cursor: pointer;">
      <v-layout row>
        <v-flex align-center d-flex style="flex: 0 0 auto;">
          <v-tooltip top>
            <v-btn @click.stop="() => { $emit('input', !value); }" :class="{'btn--active': value}" small flat icon :color="$dark() ? 'white' : 'info'" class="ma-1" slot="activator"><v-icon small style="font-size: 18px;">zoom_out_map</v-icon></v-btn>
            <span>Zoom</span>
          </v-tooltip>
        </v-flex>
        <v-flex align-center d-flex style="font-size: 12px;">
          <span>{{name}}</span>
        </v-flex>
        <v-flex align-center d-flex style="flex: 0 0 auto;">
          <v-btn small flat icon :color="$dark() ? 'white' : 'grey'" class="ma-1" @click.stop="close"><v-icon>close</v-icon></v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text class="pa-0">
      <preview :url="url" :load-player="(is_running && url != '') || (is_future && preview_url != '')" :class="{'grey lighten-1': is_past, 'black': !is_past}" style="position: relative;">
        <span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; text-align: center;" v-if="is_past" class="white--text">Event has ended</span>
        <span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; text-align: center;" v-if="is_running && url == ''" class="white--text">No preview</span>
        <span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; text-align: center;" v-if="is_future && preview_url == ''" class="white--text">Event has not yet started.</span>
      </preview>
    </v-card-text>
    <v-card-title class="pa-0 pl-2 pr-0" style="font-size: 12px; position: relative;">
      <div v-if="!is_past" :class="progress_color" :style="{'width': progress_percent + '%'}"" style="position: absolute; top: 0; left: 0; bottom: 0; z-index: 1;"></div>
      <v-menu v-if="!is_past" style="z-index: 2;">
        <v-layout slot="activator"><v-flex align-center d-flex>{{ selected_mode }}</v-flex><v-flex align-center d-flex><v-icon>arrow_drop_down</v-icon></v-flex></v-layout>
        <v-list dense>
          <v-list-tile v-for="item in modes" :key="item" @click="select_mode(item)">
            <v-list-tile-title>{{ item }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <span v-if="is_past">Ended</span>
      <v-spacer style="z-index: 2;"></v-spacer>
      <span style="z-index: 2;">{{time}}</span>
      <stop-event :uuid="data.uuid" style="z-index: 2;">
        <v-tooltip top>
          <v-btn small flat icon color="error" class="ma-1" slot="activator"><v-icon>stop</v-icon></v-btn>
          <span>End event</span>
        </v-tooltip>
      </stop-event>
    </v-card-title>
  </v-card>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import Preview from '../monitor/Preview'
import Mustache from 'mustache'
import StopEvent from '../StopEvent'

import EventModel from '@/models/event.js'

export default {
  props: ['data', 'timestamp', 'value'],
  components: {
    Preview,
    StopEvent
  },
  data() {
    return {
      modes: [
        "Preview",
        "Live"
      ],
      selected_mode: "Preview"
    }
  },
  computed: {
    card_color_class() {
      return `${this.is_running ? this.is_running_color : this.is_future && this.preview_url != '' ? this.is_future_color : ''}`
    },
    is_running_color() {
      return this.$dark() ? 'light-green darken-3' : 'green lighten-4';
    },
    progress_color() {
      if(this.is_near_to_end) {
        return this.$dark() ? "progress-warning" : 'progress-warning'
      }
      return this.$dark() ? 'light-green darken-2' : 'green lighten-5';
    },
    progress_percent() {
      if(this.is_past) return 100;
      if(this.is_running) {
        var ts = this.timestamp
        var result = Math.min(100, ((ts - this.data.cached_start_time) / (this.data.cached_end_time - this.data.cached_start_time) * 100).toFixed(2));
        return (result < 0 ? 0 : result);
      }
      return 0;
    },
    is_future_color() {
      return this.$dark() ? 'blue darken-4' : 'blue lighten-5';
    },
    is_past() {
      return EventModel.is_past(this.data, this.timestamp);
    },
    is_running() {
      return EventModel.is_current(this.data, this.timestamp);
    },
    is_near_to_end() {
      return EventModel.is_near_to_end(this.data, this.timestamp);
    },
    is_future() {
      return EventModel.is_future(this.data, this.timestamp);
    },
    output_channel() {
      return EventModel.output_channel(this.data);
    },
    input_channel() {
      return EventModel.input_channel(this.data);
    },
    output_instance() {
      return EventModel.output_instance(this.data);
    },
    preview_url() {
      return EventModel.preview_url(this.data);
    },
    url() {
      if(this.selected_mode == "Preview") return this.preview_url;
      return EventModel.live_url(this.data);
    },
    name() {
      return EventModel.title(this.data);
    },
    time() {
      return this.format_date(this.data.cached_start_time)
    }
  },
  methods: {
    select_mode (mode) {
      this.selected_mode = mode;
    },
    format_date (v) {
      return datelib.format_date(v) + " - " + datelib.format_time(v);
    },
    open_editor() {
      this.$router.push("/multiview/event/"+this.data.uuid)
    },
    close() {
      if (!this.$store.state.account) return;
      var acc = _.cloneDeep(this.$store.state.account);
      acc.meta.multiview_event_filter = _.xor(acc.meta.multiview_event_filter, [this.data.uuid]);
      this.$store.dispatch("update_profile", acc);
    }
  }
}
</script>
<style scoped>
  .progress-warning {
    animation: rotate-bg-color 0.5s infinite;
  }

  .theme--dark .progress-warning {
    animation: rotate-bg-color-dark 0.5s infinite;
  }


  @keyframes rotate-bg-color-dark {
    0% {
      background-color: #C62828;
    }
    50% {
      background-color: #689F38;
    }
    100% {
      background-color: #C62828;
    }
  }

  @keyframes rotate-bg-color {
    0% {
      background-color: #EF9A9A;
    }
    50% {
      background-color: #E8F5E9;
    }
    100% {
      background-color: #EF9A9A;
    }
  }
</style>